import {Module} from '../../../../IoC/Module';
import {TrackersStore} from '../stores/Trackers/Trackers.store';
import {trackersContainerFactoryJrpc} from './trackersContainerFactory.jrpc';

export type {};

export const trackersModule = new Module(
  'trackers',
  trackersContainerFactoryJrpc,
  {
    TrackersStore,
  },
);
